/**
 *  Create Path with /additionals/ prefix base route to redirect properly to API.
 *
 * @param {string} path - Path to be completed with /additionals base path.
 *
 * @returns API path with correct prefix.
 */
const BASE_PATH = process.env.PUBLIC_URL || "";
const generatePathRoute = (path: string): string => `${BASE_PATH}${path}`;

export { generatePathRoute };
